import { Pagination, Space, Table, Tooltip } from "antd";
// import moment from "moment";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ReactComponent as Trash } from "../../../../assets/images/svgs/trash.svg";
import AddNewBrandModal from "../../../../components/modals/AddNewBrandModal";
import ProductModal from "../../../../components/modals/ProductModal";
import { getRemittances } from "../../../../store/actions/remittance.action";
import { RemittanceService } from "../../../../utils/services/remittance.service";
// import FixedAmountFee from "./atom/FixedAmountFee";

import { BsPlusCircleFill } from "react-icons/bs";

const Body = ({
  domainBrand,
  currency,
  countries,
  remittance = [],
  isLoading,
  partnerAgent,
  corridor,
  userId,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { Column } = Table;
  const [filterInput, setFilterInput] = useState("");
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
  const [type, setType] = useState("");
  // const [addNewState, updateState] = useState(false);
  const [loading, setLoading] = useState(false);

  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const languageStatus = !(
    typeof dictionary === "undefined" || dictionary === null
  );

  const tableData =
    remittance &&
    remittance?.map((i, index) => {
      return { ...i, key: index + 1 };
    });

  const handleDelete = async (id) => {
    setLoading(true);
    try {
      const response = await RemittanceService.deleteRemittance(id);
      if (response.data.status === "SUCCESS") {
        toast.success(response.data.message);
        dispatch(getRemittances(1, "MONEYTRANSFER", 10));
      } else {
        toast.error(response.data.message);
      }
      setLoading(false);
      setOpen(false);
    } catch (error) {
      setLoading(false);
      setOpen(false);
      return error;
    }
    setLoading(false);
  };

  const onChange = (page) => {
    // setPageSize(page);
    dispatch(getRemittances(page, "MONEYTRANSFER", 10));
  };

  const imtoArr =
    partnerAgent &&
    partnerAgent?.map((i) => {
      return { label: i?.name, value: i?.id };
    });

  const corridorData =
    corridor &&
    corridor?.map((i) => {
      return {
        label: `${i.tradeOriginatingCountry}>>${i.destinationCountry}>>${i.deliveryMethod}`,
        value: i.id,
      };
    });

  return (
    <React.Fragment>
      <AddNewBrandModal
        show={show}
        handleClose={() => setShow(false)}
        domainBrand={domainBrand}
        imtoArr={imtoArr}
        corridorData={corridorData}
        userId={userId}
      />

      <ProductModal
        show={open}
        type={"DELETE-REMITTANCE-FEE"}
        handleClose={() => setOpen(false)}
        kyc={type}
        handleDeleteIntRate={() => handleDelete(id)}
        loading={loading}
      />

      <div className="app-content hor-content">
        <div className="container">
          <div className="page-header">
            <div>
              <h1 className="page-title">
                {languageStatus
                  ? dictionary["para_money_transfer_charges_1"]
                  : "Money Transfer Fee"}
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item active" aria-current="page">
                  {languageStatus
                    ? dictionary["WO_A_FEE_BAND_IS_A_SET_-1512307040"]
                    : "A fee band is a set of rules governing how much customers will pay for each service."}
                </li>
              </ol>
            </div>
          </div>
          <div className="row row-sm">
            <div className="col-lg-12">
              <div className="form-row">
                <div className="col-md-6 col-lg-6">
                  <button
                    className="btn btn-primary w-100 fw-bold mb-2"
                    type="button"
                    onClick={() => setShow(true)}
                  >
                    <BsPlusCircleFill />{" "}
                    <span className="align-middle text-uppercase">
                      {dictionary
                        ? dictionary["WO_ADD_NEW_FE_347231003"]
                        : "ADD NEW BAND"}
                    </span>
                  </button>
                </div>

                <div className="col-md-6 col-lg-6">
                  <button
                    className="btn btn-primary w-100 fw-bold mb-2"
                    type="button"
                    onClick={() => history.push("/fee/fixed-amount-fee")}
                  >
                    <BsPlusCircleFill />{" "}
                    <span className="align-middle">
                      {dictionary
                        ? dictionary["WO_ADD_FIXED_AMOUNT_FE_-1218358524"]
                        : "ADD FIXED AMOUNT FEE"}
                    </span>
                  </button>
                </div>
              </div>
              {/* {addNewState && (
                <FixedAmountFee
                  dictionary={dictionary}
                  languageStatus={languageStatus}
                  domainBrand={domainBrand}
                  currency={currency}
                  countries={countries}
                />
              )} */}
            </div>

            <div className="col-lg-12">
              <div className="card overflow-hidden">
                <div className="card-header bg-primary text-white">
                  <h3 className="card-title">REMITTANCES</h3>
                </div>
                <div className="card-body">
                  <div className="col-md-6 col-lg-6">
                    <p className="text-muted card-sub-title">
                      Sort and filter table
                    </p>

                    <input
                      type={"text"}
                      className="form-control border px-3"
                      value={filterInput}
                      onChange={(e) => setFilterInput(e.target.value)}
                      placeholder="Search..."
                      autoComplete=""
                    />
                  </div>

                  <div className="table-responsive mt-5">
                    <Table
                      dataSource={tableData}
                      className="w-100 table tbody"
                      loading={isLoading}
                      pagination={false}
                    >
                      <Column
                        title="Ref Code"
                        dataIndex="chargeRef"
                        key="1"
                        className=""
                        render={(text) => {
                          return <span>{text}</span>;
                        }}
                        sorter={(a, b) => a.lastLoginTime - b.lastLoginTime}
                      />
                      <Column
                        title="Currency pairs"
                        dataIndex="currency"
                        key="1"
                        className=""
                        render={(text) => {
                          return <span>{text}</span>;
                        }}
                      />
                      <Column
                        title="Destination country"
                        dataIndex="country"
                        key="1"
                        className=""
                        sorter={(a, b) => a.lastLoginTime - b.lastLoginTime}
                      />
                      <Column
                        title="Delivery Method"
                        dataIndex="supportedFeeType"
                        key="1"
                        className=""
                        render={(text) => {
                          return <span>{text}</span>;
                        }}
                        sorter={(a, b) => a.lastLoginTime - b.lastLoginTime}
                      />
                      <Column
                        title="Rate Type"
                        dataIndex="rateType"
                        key="1"
                        className=""
                        render={(text) => {
                          return <span>{text}</span>;
                        }}
                        sorter={(a, b) => a.lastLoginTime - b.lastLoginTime}
                      />
                      <Column
                        title="Fee"
                        dataIndex="fee"
                        key="1"
                        className=""
                        render={(text) => {
                          return <span>{text}</span>;
                        }}
                        sorter={(a, b) => a.lastLoginTime - b.lastLoginTime}
                      />
                      <Column
                        title="Action"
                        dataIndex="action"
                        key="6"
                        className=""
                        render={(text, record) => {
                          return (
                            <>
                              <Space size="small">
                                <Tooltip
                                  title={"Delete"}
                                  color="#212529"
                                  placement="bottom"
                                  arrowPointAtCenter={true}
                                >
                                  <Trash
                                    onClick={() => {
                                      setOpen(true);
                                      setId(record?.id);
                                      setType(record?.chargeRef);
                                    }}
                                  />
                                </Tooltip>
                              </Space>
                            </>
                          );
                        }}
                      />
                    </Table>
                  </div>
                  <Pagination
                    total={remittance?.length}
                    responsive
                    onChange={(page) => {
                      onChange(page, 10);
                    }}
                    className="float-end pt-1 pb-4"
                    showTotal={(total, range) => {
                      return `Showing ${range[0]}-${range[1]} of ${total} items`;
                    }}
                    showSizeChanger={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Body;
